<template>
  <div v-if="airalo_simcard_info" class="airalo_simcard_info">
    <div class="airalo_simcard_info__left">
      <div class="airalo_simcard_info__left__wrap" ref="content">
        <div class="main_info" ref="main_info">
          <div class="line row">
            <div class="col-md-4 col-sm-4">
              <fg-input v-model="airalo_simcard_info.name" type="text" :label="translate('airalo.name')"
                        :placeholder="translate('airalo.name')" :readonly="true"/>
            </div>

            <div class="col-md-3 col-sm-3">
              <fg-input v-model="airalo_simcard_info.apn_value" type="text" :label="translate('airalo.apn_value')"
                        :placeholder="translate('airalo.apn_value')" :readonly="true"/>
            </div>

            <div class="col-md-2 col-sm-2">
              <fg-input v-model="airalo_active" type="text" :label="translate('airalo.status')"
                        :placeholder="translate('airalo.status')" :readonly="true"/>
            </div>

            <div class="col-md-3 col-sm-3">
              <fg-input v-model="airalo_activated" type="text" :label="translate('airalo.activated')"
                        :placeholder="translate('airalo.activated')" :readonly="true"/>
            </div>
          </div>

          <div class="line row">
            <div class="col-md-3 col-sm-3">
              <fg-input v-model="airalo_simcard_info.iccid" type="text" :label="translate('airalo.iccid')"
                        :placeholder="translate('airalo.iccid')" :readonly="true"/>
            </div>
            <div class="col-md-3 col-sm-3">
              <fg-input v-model="airalo_simcard_info.package_id" type="text" :label="translate('airalo.package_id')"
                        :placeholder="translate('airalo.package_id')" :readonly="true"/>
            </div>
            <div class="col-md-3 col-sm-3">
              <fg-input v-model="airalo_unlimited" type="text" :label="translate('airalo.is_unlimited')"
                        :placeholder="translate('airalo.is_unlimited')" :readonly="true"/>
            </div>
            <div class="col-md-3 col-sm-3">
              <fg-input v-model="airalo_expired" type="text" :label="translate('airalo.expires')"
                        :placeholder="translate('airalo.expires')" :readonly="true"/>
            </div>
          </div>

          <div class="line row">
            <div class="col-md-12 col-sm-12 text_wrap">
              <div class="form-group">
                <label>{{ translate('airalo.comment') }}</label>
                <textarea class="input_text" name="equipment" v-model="airalo_simcard_info.comment" :rows="4" />
              </div>
            </div>
          </div>

          <div class="line text-center buttons" >
            <span
                v-if="airalo_simcard_info.active === 1"
                class="btn btn-success btn-fill btn-wd"
                @click.prevent="edit_status_airalo_simcard(0)"
            >
                {{ translate('airalo.stop_tracking') }}
            </span>
            <span v-if="has_changes" class="btn btn-success btn-fill btn-wd" @click.prevent="edit_airalo">
              {{ translate('btn.edit') }}
            </span>
          </div>

        </div>
      </div>

      <div class="response_table" v-if="airalo_simcard_info.orders?.length > 0">
        <div class="header_orders">
          <h4 class="title">
            {{ translate("airalo.order_list") }}
            ({{ airalo_simcard_info.orders.length }})
          </h4>
        </div>
        <table>
          <thead style="flex: 0">
          <tr>
            <th scope="col">
              id
            </th>
            <th scope="col">
              code
            </th>
            <th scope="col">
              package_id
            </th>
            <th scope="col">
              ts_create
            </th>
          </tr>
          </thead>
          <tbody>
            <tr class="device" v-for="(order, key) in airalo_simcard_info.orders" :key="key">
              <td data-label="id">
                {{ order.id }}
              </td>
              <td data-label="code">
                {{ order.code }}
              </td>
              <td data-label="package_id">
                {{ order.package_id }}
              </td>
              <td data-label="ts_create">
                {{ get_date(order.ts_create) }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>




    </div>

<!--    <div class="airalo_simcard_info__right">-->
<!--      <Summary type="airalo_simcard" :info="airalo_simcard_info" :view_history="false" />-->
<!--    </div>-->
  </div>

</template>
<script>
import Summary from "components/UIComponents/Summary/Summary.vue";

const fields_to_check = ["comment"];

export default {
  name: 'AiraloSimcardInfo',
  components: {
    Summary
  },

  props: {
    airalo_simcard: {
      type: Object,
      required: true
    }
  },

  data() {
    return {
      airalo_simcard_info: {},
    }
  },

  created() {
    this.airalo_simcard_info = JSON.parse(JSON.stringify(this.airalo_simcard))
  },

  activated() {
    this.airalo_simcard_info = JSON.parse(JSON.stringify(this.airalo_simcard))
  },

  computed: {
    has_changes() {
      let airalo_simcard = fields_to_check.reduce((obj, key) => {
        obj[key] = this.airalo_simcard[key];
        return obj;
      }, {});

      let airalo_simcard_info = fields_to_check.reduce((obj, key) => {
        obj[key] = this.airalo_simcard_info[key];
        return obj;
      }, {});

      return JSON.stringify(airalo_simcard) !== JSON.stringify(airalo_simcard_info);
    },
    airalo_active(){
      return this.airalo_simcard_info.active === 1 ? this.translate("airalo.filter.active") : this.airalo_simcard_info.active === 0 ? this.translate("airalo.filter.not_active") : ""
    },
    airalo_unlimited(){
      return this.airalo_simcard_info.is_unlimited === 1 ? "Да" : this.airalo_simcard_info.is_unlimited === 0 ? "Нет" : ""
    },
    airalo_activated(){
      return this.get_date(+new Date(this.airalo_simcard_info.activated_at) / 1000)
    },
    airalo_expired(){
      return this.get_date(+new Date(this.airalo_simcard_info.expired_at) / 1000)
    }
  },

  watch: {
    airalo_simcard(){
      this.airalo_simcard_info = {...this.airalo_simcard}
    }
  },

  methods: {
    edit_airalo() {
      let airalo_simcard_info = fields_to_check.reduce((obj, key) => {
        obj[key] = this.airalo_simcard_info[key];
        return obj;
      }, {});

      this.$http.simcard.updateAiraloSimcard(this.airalo_simcard_info.id, airalo_simcard_info, (response) => {
        this.global_notify('info', this.translate('airalo.saved_success'))
        this.airalo_simcard_info = response.data
        this.$emit('update_data', response.data)
      })
    },
    edit_status_airalo_simcard(active) {
      this.$http.simcard.updateStatusAiraloSimcard(this.airalo_simcard_info.iccid, {active}, (response) => {
        this.global_notify('info', this.translate('airalo.update_status'))
        this.airalo_simcard_info = response.data
        this.$emit('update')
      })
    },
  }
}

</script>

<style lang='scss' scoped>
.airalo_simcard_info {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  overflow: auto;

  @media (max-width: 991px) {
    flex-direction: column;
  }

  &__left {
    width: 70%;
    height: 100%;
    padding-right: 10px;
    @media (max-width: 991px) {
      width: 100%;
      height: auto;
    }

    .buttons{
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 10px;
    }

    .form_select{
      .form-control {
        width: 100%;
      }
    }

    .response_table {
      height: auto;
      padding: 10px 0 0;
      .header_orders{
        .title{
          font-size: 12px;
          margin: 0 0 10px;

        }
      }

      .status {
        width: 5%;
      }

      table {
        td {
          padding: 5px;
        }
      }
    }
  }

  &__right {
    width: 30%;
    height: 100%;
    @media (max-width: 991px) {
      width: 100%;
      height: auto;
    }
  }
}
</style>
